<template>
  <div
    class="full-item flex flex-direction justify-center align-center login-container min-body-height"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-bottom-100') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix"><span>修改密码</span></div>
      <ChangePwd
        :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"
      ></ChangePwd>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ChangePwd from './changePwd.vue';

export default {
  components: {
    ChangePwd,
  },

  computed: {
    ...mapState(['UI']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/changePwd/index.vue